'use client';

export {
    generate as generateProductShippingDetail,
    showCutList as productShippingDetailShowCutList,
    createProductShippingDetail,
} from './define';
export { ProductShippingDetail } from './ProductShippingDetail';
